module.exports = __webpack_public_path__ + "img/W7015-tran.8c0684d8.jpg";